export default function KPIBar({ kpi, isLocked }) {
  const cards = [
    { label: 'On Target',    value: kpi.good,      color: '#16A34A', bg: '#DCFCE7', border: '#86EFAC' },
    { label: 'At Risk',      value: kpi.risk,      color: '#A16207', bg: '#FEF9C3', border: '#FDE047' },
    { label: 'Off Track',    value: kpi.off,       color: '#DC2626', bg: '#FEE2E2', border: '#FCA5A5' },
    { label: 'Total Metrics',value: kpi.total,     color: '#374151', bg: '#F9FAFB', border: '#E5E7EB' },
    { label: 'Commented',    value: kpi.commented, color: '#1D4ED8', bg: '#EFF6FF', border: '#93C5FD' },
  ];

  return (
    <div style={s.row}>
      {cards.map((c) => (
        <div key={c.label} style={{ ...s.card, background: c.bg, borderColor: c.border }}>
          <div style={{ ...s.label, color: c.color }}>{c.label}</div>
          <div style={{ ...s.val,   color: c.color }}>{c.value}</div>
        </div>
      ))}
      {isLocked && (
        <div style={s.lockBadge}>🔒 Submitted</div>
      )}
    </div>
  );
}

const s = {
  row:       { display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px', alignItems: 'center' },
  card:      { flex: '1 1 100px', minWidth: '90px', padding: '10px 14px', borderRadius: '8px', border: '1px solid' },
  label:     { fontSize: '9px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', marginBottom: '3px' },
  val:       { fontSize: '22px', fontWeight: 700 },
  lockBadge: { marginLeft: 'auto', fontSize: '12px', color: '#16A34A', fontWeight: 600, padding: '6px 12px', background: '#DCFCE7', borderRadius: '20px', border: '1px solid #86EFAC' },
};